//Login
export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";

//Agency
//Document Forme
export const RESET_DOCUMENT_BUILD_FORM = "RESET_DOCUMENT_BUILD_FORM";
export const DOCUMENT_GOTO_NEXT_STEP = "DOCUMENT_GOTO_NEXT_STEP";
export const DOCUMENT_GOTO_PREVIOUS_STEP = "DOCUMENT_GOTO_PREVIOUS_STEP";
export const STEP_2_SET_UPLOAD_DOCUMENT = "STEP_2_SET_UPLOAD_DOCUMENT";
export const STEP_2_UPDATE_DOCUMENTS_ARRAY = "STEP_2_UPDATE_DOCUMENTS_ARRAY";
export const SET_STEP_2_UPLOAD_DOCUMENTS = "SET_STEP_2_UPLOAD_DOCUMENTS";
export const STEP_2_REMOVE_DOCUMENT = "STEP_2_REMOVE_DOCUMENT";
export const SET_STEP_2_UPDATE_DOCUMENT = "SET_STEP_2_UPDATE_DOCUMENT";
export const STEP_2_INSERT_DOCUMENT_BETWEEN_PAGES =
  "STEP_2_INSERT_DOCUMENT_BETWEEN_PAGES";
export const STEP_1_ADD_REQUIRED_DOCUMENT = "STEP_1_ADD_REQUIRED_DOCUMENT";
export const STEP_1_REMOVE_REQUIRED_DOCUMENT =
  "STEP_1_REMOVE_REQUIRED_DOCUMENT";
export const STEP_1_REQUIRED_DOCUMENT_FIELD_VALUES =
  "STEP_1_REQUIRED_DOCUMENT_FIELD_VALUES";
export const STEP_ONE_CREATE_COMPLETE = "STEP_ONE_CREATE_COMPLETE";
export const SET_DOCUMENT_FORM_AS_EDITABLE = "SET_DOCUMENT_FORM_AS_EDITABLE";
export const SET_AND_RESET_ADDITIONAL_DOCUMENTS =
  "SET_AND_RESET_ADDITIONAL_DOCUMENTS";
export const SET_VARIABLES_LIST = "SET_VARIABLES_LIST";
export const SET_DOCUMENT_TYPE = "SET_DOCUMENT_TYPE";
export const SET_DOCUMENT_FORMAT = "SET_DOCUMENT_FORMAT";

//End User
export const GOTO_NEXT_STEP = "GOTO_NEXT_STEP";
export const GOTO_PREVIOUS_STEP = "GOTO_PREVIOUS_STEP";
export const SET_BASICFORM_VALUES = "SET_BASICFORM_VALUES";
export const SET_APPLICATION_PLACEHOLDERS = "SET_APPLICATION_PLACEHOLDERS";
export const SET_APPLICATION_VALUES = "SET_APPLICATION_VALUES";
export const GOTO_SELECTED_STEP = "GOTO_SELECTED_STEP";
export const SET_PDF_BLOB = "SET_PDF_BLOB";
export const SET_ADDITIONAL_DOCUMENT_URL = "SET_ADDITIONAL_DOCUMENT_URL";
export const APPLICATION_STEP_ONE_SET_FIELD_VALUES =
  "APPLICATION_STEP_ONE_SET_FIELD_VALUES";
export const RESET_APPLICATION_FORM = "RESET_APPLICATION_FORM";
export const SET_CONVENIENCE_FEE = "SET_CONVENIENCE_FEE";
export const SAVE_BASE64_WEBFORM = "SAVE_BASE64_WEBFORM";

//Admin
//Admin CRUD
export const SET_ADMIN_FORM_PROFILE_PICTURE = "SET_ADMIN_FORM_PROFILE_PICTURE";

//Agency User
export const SET_AGENCY_USER_PROFILE_PICTURE =
  "SET_AGENCY_USER_PROFILE_PICTURE";

//
//Form
export const ADD_NEW_FIELD = "ADD_NEW_FIELD";
export const ADD_OPTION = "ADD_OPTION";
export const GET_DATA = "GET_DATA";
export const DELETE = "DELETE";
export const SINGLE_DATA = "SINGLE_DATA";
export const VALUE_CHANGES = "VALUE_CHANGES";
export const DRAG_DROP = "DRAG_DROP";
export const DUPLICATE = "DUPLICATE";
export const OPTION_VALUES = "OPTION_VALUES";
export const OPTION_DELETE = "OPTION_DELETE";
export const RESET_STATE = "RESET_STATE";
export const ADD_DUPLICATE = "ADD_DUPLICATE";
//document
export const ADD_DOCUMENT = "ADD_DOCUMENT";
export const DELETE_DOCUMENT = "DELETE_DOCUMENT";
export const DOCUMENT_VALUE = "DOCUMENT_VALUE";
export const FORM_DETAILS = "FORM_DETAILS";
export const NEW_FROM = "NEW_FROM";
export const DOCUMENT_DETAILS = "DOCUMENT_DETAILS";
export const NEW_DOCUMENT = "NEW_DOCUMENT";
export const SAVE_VALUE = "SAVE_VALUE";
export const SAVE_FILED_VALUE = "SAVE_FILED_VALUE";
//
export const CATEGORY_DETAILS = "CATEGORY_DETAILS";
export const NEWFORM = "NEWFORM";
export const ADD_CATEGORY = "ADD_CATEGORY";
export const CATEGORY_ONCHANGE = "CATEGORY_ONCHANGE";

// Instruction

export const INSTRUCTION_ADD_NEW_FIELD = "INSTRUCTION_ADD_NEW_FIELD";
export const INSTRUCTION_DELETE = "INSTRUCTION_DELETE";
export const INSTRUCTION_VALUE_CHANGES = "INSTRUCTION_VALUE_CHANGES";
export const INSTRUCTION_DRAG_DROP = "INSTRUCTION_DRAG_DROP";
export const INSTRUCTION_RESET_STATE = "INSTRUCTION_RESET_STATE";
export const INSTRUCTION_FORM_DETAILS = "INSTRUCTION_FORM_DETAILS";
export const INSTRUCTION_NEW_FROM = "INSTRUCTION_NEW_FROM";
export const INSTRUCTION_SAVE_VALUE = "INSTRUCTION_SAVE_VALUE";
export const INSTRUCTION_SAVE_FILED_VALUE = "INSTRUCTION_SAVE_FILED_VALUE";
export const INSTRUCTION_LOAD_VALUE = "INSTRUCTION_LOAD_VALUE";

//Invoices
export const INVOICE_VALUE_CHANGE = "INVOICE_VALUE_CHANGE";

//Invoice Listing
export const INVOICE_LISTING_LOADING = "INVOICE_LISTING_LOADING";
export const INVOICE_LISTING_SUCCESS = "INVOICE_LISTING_SUCCESS";
export const INVOICE_LISTING_ERROR = "INVOICE_LISTING_ERROR";

//Invoice Detail
export const INVOICE_DETAIL_LOADING = "INVOICE_DETAIL_LOADING";
export const INVOICE_DETAIL_SUCCESS = "INVOICE_DETAIL_SUCCESS";
export const INVOICE_DETAIL_ERROR = "INVOICE_DETAIL_ERROR";

//Customer Listing
export const CUSTOMER_LISTING_LOADING = "CUSTOMER_LISTING_LOADING";
export const CUSTOMER_LISTING_SUCCESS = "CUSTOMER_LISTING_SUCCESS";
export const CUSTOMER_LISTING_ERROR = "CUSTOMER_LISTING_ERROR";

//Coupon Details
export const COUPON_DETAIL_LOADING = "COUPON_DETAIL_LOADING";
export const COUPON_DETAIL_SUCCESS = "COUPON_DETAIL_SUCCESS";
export const COUPON_DETAIL_ERROR = "COUPON_DETAIL_ERROR";

//Invoice Form
export const INVOICE_ADD_LINE_ITEM = "INVOICE_ADD_LINE_ITEM";
export const INVOICE_LINE_ITEM_VALUES = "INVOICE_LINE_ITEM_VALUES";
export const INVOICE_DELETE_LINE_ITEM = "INVOICE_DELETE_LINE_ITEM";
export const INVOICE_UPDATE_FORM_BASE_VALUES =
  "INVOICE_UPDATE_FORM_BASE_VALUES";
export const SAVE_INVOICE_FORM_REDUCER = "SAVE_INVOICE_FORM_REDUCER";
export const RESET_INVOICE_FORM_REDUCER = "RESET_INVOICE_FORM_REDUCER";

//Location Code
export const LOCATION_CODE_LISTING_LOADING = "LOCATION_CODE_LISTING_LOADING";
export const LOCATION_CODE_LISTING_SUCCESS = "LOCATION_CODE_LISTING_SUCCESS";
